import React from "react";
import CorpAcc from "../../../assets/images/subscription.png";
import "./CorporateSetting.css";
import Logo from "../../../assets/images/logo-blue.png";

function CorporateSubs () {

  const subsService = [
    "Schedule telemed calls",
    "Record diagnoses",
    "Update problem list",
    "Record medical orders",
    "Create progress note",
  ];

    return (
      <div
        style={{
          height: "100vh",
          background: "#f8f9fa",
          overflowY: "auto"
        }}
      >
      <div
        className="container"
        style={{ background: "#f8f9fa" }}
        id="corporateSub"
      >
        <div className="logo-subs">
          <img
            width="50"
            height="50"
            src={Logo}
            alt="H"
          />
          <span
            className="hc-primary-text d-none d-md-inline"
          >
            HUBCHART
          </span>
        </div>
        <div align="center" className="subs-header row">
          <span className="col-xl-12">
            <img width="250" height="150" src={CorpAcc} alt="H"></img></span>
          <span className="col-xl-12">
            <h3>Corporate Account</h3>
          </span>
          <span className="col-xl-12">
            <p style={{ fontStyle: "italic" }}>
              Revolutionizing Patient-Centric Healthcare
            </p>
          </span>
          <span className="col-xl-12">
            <p style={{backgroundColor:'#f8f9fa'}}>
              Hubchart Corporate plan brings together the power of telemedicine
              and team collaboration, revolutionizing the way you deliver
              healthcare. Take advantage of our subscription to unlock the full
              potential of collaborative care, streamline workflows, and enhance
              patient outcomes.
            </p>
          </span>
        </div>
        <br />
        <div className="row">
          <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4" style={{ marginBottom: 20 }}>
            <div className="subs-container">
              <h3>Corp. Starter</h3>
              <div>
                <h2>$ 9.99</h2>
                <p style={{ paddingTop: "15px" }}>/ month</p>
              </div>
              <button type="button" className="btn-subs" onClick={() => {}}
                >
                <span className="d-none d-sm-block d-sm-none d-md-block">
                  Get started
                </span>
              </button>
              <br />
              <hr />
              <ul className="ul-subs" align="left">
                <li>
                  <i className="fa fa-check"></i> Add up to 20 Corp. members and
                  guest
                </li>
                <li>
                  <i className="fa fa-check"></i> Create up to 1,000 patient
                  hubs
                </li>
                {subsService.map((item) => {
                  return (
                    <li>
                      <i className="fa fa-check"></i> {item}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4" style={{ marginBottom: 20 }}>
            <div className="subs-container">
              <h3>Corp. Standard</h3>
              <div>
                <h2>$ 49.99</h2>
                <p style={{ paddingTop: "15px" }}>/ month</p>
              </div>
              <button type="button" className="btn-subs" onClick={() => {}}>
                <span className="d-none d-sm-block d-sm-none d-md-block">
                  Get started
                </span>
              </button>
              <br />
              <hr />
              <ul className="ul-subs" align="left">
                <li>
                  <i className="fa fa-check"></i> Add up to 50 Corp. members and
                  guest
                </li>
                <li>
                  <i className="fa fa-check"></i> Create up to 3,000 patient
                  hubs
                </li>
                {subsService.map((item) => {
                  return (
                    <li>
                      <i className="fa fa-check"></i> {item}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4" style={{ marginBottom: 20 }}>
            <div className="subs-container">
              <h3>Corp. Plus</h3>
              <div>
                <h2>$ 99.99</h2>
                <p style={{ paddingTop: "15px" }}>/ month</p>
              </div>
              <button type="button" className="btn-subs">
                <span className="d-none d-sm-block d-sm-none d-md-block">
                  Get started
                </span>
              </button>
              <br />
              <hr />
              <ul className="ul-subs" align="left">
                <li>
                  <i className="fa fa-check"></i> Add up to 100 Corp. members
                  and guest
                </li>
                <li>
                  <i className="fa fa-check"></i> Create up to 5,000 patient
                  hubs
                </li>
                {subsService.map((item) => {
                  return (
                    <li>
                      <i className="fa fa-check"></i> {item}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
      </div>
    );
}

export default CorporateSubs;